<template>
    <div>
        <div class="tw-mb-8">
            <div
                class="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-pt-3 tw-pb-3 tw-mb-8 tw-rounded-lg tw-uppercase"
            >
                <div class="tw-col-span-6 tw-font-semibold tw-pl-4">
                    {{
                        (teamSettings.customWording && teamSettings.customWording.reviews) ||
                            $t("teamDashboard.reviewsTitle")
                    }}
                </div>
                <div class="tw-col-span-4 color-grey">
                    {{ $t("teamDashboard.reviewsLatest") }}
                </div>
                <div class="tw-col-span-2 color-grey">
                    {{ $t("teamDashboard.reviewsProgress") }}
                </div>
            </div>
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!participantProgress.length" class="tw-text-gray-400">
                {{ $t("teamDashboard.reviewsEmpty") }}
            </div>

            <div v-else>
                <div v-for="employee in participantProgress" :key="employee._id">
                    <l-reviews-progress-list-item :employee="employee" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSkeletonLoader from "@/components/LSkeletonLoader";
import LReviewsProgressListItem from "@/components/LReviewsProgressListItem";

export default {
    components: {
        LSkeletonLoader,
        LReviewsProgressListItem,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            types: ["goalTeam", "goalLocalTeam", "goalUser"],
        };
    },
    computed: {
        ...mapGetters({
            participantProgress: "reviews/assessments/participantProgress",
            teamSettings: "users/current/teamSettings",
        }),
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.isLoading = true;

            try {
                await this.$store.dispatch("reviews/assessments/getParticipantProgress", {
                    payload: {
                        userFilter: { include: { admin: [{ _id: "reportsSearch" }] } },
                        reset: true,
                    },
                });
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
